export default "__VITE_ASSET__DCoDRXca__"